<ng-container *transloco="let t">
  @let current = summary();

  <img
    alt="DressFit"
    class="size-10 shrink-0 object-contain"
    data-testid="banner-logo"
    height="40"
    width="40"
    [src]="logo" />

  <!--
    Every line stays on one line and fades out (tuiFade) where it runs out of room. On the first line
    the price never shrinks: it holds its place at the right edge and the count fades out under it.
  -->
  <div class="flex min-w-0 flex-1 flex-col justify-center" data-testid="banner-status">
    @switch (current.status) {
      @case ('recommendations') {
        <div class="flex w-full min-w-0 items-center gap-1.5 font-medium">
          <p class="min-w-0 overflow-hidden whitespace-nowrap text-xs text-text-secondary" tuiFade>
            {{ t('{count, plural, one {# recommandation} other {# recommandations}}', { count: current.count }) }}
          </p>
          @if (priceRange(); as price) {
            <p class="shrink-0 whitespace-nowrap text-xs text-text-success-primary" data-testid="banner-price">
              {{ price }}
            </p>
          }
        </div>
        <p class="w-full overflow-hidden whitespace-nowrap text-xs text-text-tertiary" tuiFade>{{ familyNames() }}</p>
      }
      @case ('selected') {
        <p class="w-full overflow-hidden whitespace-nowrap text-xs text-text-tertiary" tuiFade>{{ t('Sélection') }}</p>
        <p class="w-full overflow-hidden whitespace-nowrap text-xs font-medium text-text-brand-secondary" tuiFade>
          {{ dressingNames() }}
        </p>
      }
      @case ('no-match') {
        <p class="w-full overflow-hidden whitespace-nowrap text-xs font-medium text-text-tertiary" tuiFade>
          {{ t('Aucun résultat') }}
        </p>
      }
      @case ('search-only') {
        <p class="w-full overflow-hidden whitespace-nowrap text-xs font-medium text-text-tertiary" tuiFade>
          {{ t('Utilisez la recherche') }}
        </p>
      }
      @default {
        <p class="w-full overflow-hidden whitespace-nowrap text-xs font-medium text-text-tertiary" tuiFade>
          {{ t('En attente de données') }}
        </p>
      }
    }
  </div>

  <button
    appearance="secondary"
    class="shrink-0"
    data-testid="banner-details"
    size="xs"
    tuiButton
    type="button"
    (click)="openPanel()">
    {{ t('Détails') }}
  </button>
</ng-container>
